export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-format/src/identity.js
// module id = 242
// module chunks = 0